import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { Button } from "../components/ui/button";
import { FileQuestion, UserSearch, PenLine, UploadCloud } from "lucide-react";

function TypeCard({ icon, accent, title, desc, formTo, bulkTo, testid }) {
  const { t } = useI18n();
  return (
    <div
      className="flex h-full flex-col rounded-xl border border-[#E2E8F0] bg-white p-6 shadow-sm transition-base hover:shadow-md"
      style={{ borderColor: undefined }}
      data-testid={testid}
    >
      <span className="grid h-12 w-12 place-items-center rounded-lg" style={{ backgroundColor: `${accent}1a`, color: accent }}>
        {icon}
      </span>
      <h2 className="mt-4 font-heading text-lg font-semibold text-[#1A2024]">{title}</h2>
      <p className="mt-2 flex-1 font-body text-sm text-[#5C6873]">{desc}</p>
      <div className="mt-5 flex flex-col gap-2">
        <Link to={formTo} data-testid={`${testid}-form-btn`}>
          <Button className="w-full justify-start text-white" style={{ backgroundColor: accent }}>
            <PenLine size={15} className="mr-2" /> {t("choose.single")}
          </Button>
        </Link>
        <Link to={bulkTo} data-testid={`${testid}-bulk-btn`}>
          <Button variant="outline" className="w-full justify-start border-[#E2E8F0] text-[#2E3A46]">
            <UploadCloud size={15} className="mr-2" /> {t("choose.bulk")}
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default function ChooseCaseTypePage() {
  const { t } = useI18n();
  return (
    <div className="mx-auto max-w-3xl px-6 py-12" data-testid="choose-case-type-page">
      <p className="font-body text-xs uppercase tracking-[0.18em] text-[#6B7F82]">{t("dash.workspace.authority")}</p>
      <h1 className="mt-1 font-heading text-3xl font-semibold text-[#1A2024]">{t("choose.title")}</h1>
      <p className="mt-2 max-w-xl font-body text-sm text-[#5C6873]">{t("choose.sub")}</p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2">
        <TypeCard
          icon={<FileQuestion size={24} />}
          accent="#1F3A5F"
          title={t("choose.post.title")}
          desc={t("choose.post.desc")}
          formTo="/post-mortem/new"
          bulkTo="/admin/import?kind=post"
          testid="choose-post-card"
        />
        <TypeCard
          icon={<UserSearch size={24} />}
          accent="#4A7C59"
          title={t("choose.ante.title")}
          desc={t("choose.ante.desc")}
          formTo="/ante-mortem/new"
          bulkTo="/admin/import?kind=ante"
          testid="choose-ante-card"
        />
      </div>
    </div>
  );
}
